import { useCallback, useState } from "react";
import useTokenHook from "../../context/useTokenHook";
import {
  getVisualIndicatorEstimate,
  getVisualIndicatorStatus,
  saveVisualIndicator,
  stopVisualIndicator,
} from "../../../utils/requests/accountSettingsRequest";
import type {
  VisualIndicatorMode,
  VisualIndicatorSetting,
} from "../../../components/Navbar/Settings/types/settings-drawer-interface";

/**
 * The visual indicator routes (plan I6). `save` with mode "swap" or "remove" queues a bulk rename
 * and resolves with its requestId; mode "save" only changes the account's indicator for new syncs.
 */
const useVisualIndicator = () => {
  const { token } = useTokenHook();
  const [saving, setSaving] = useState(false);

  const save = useCallback(
    async (mode: VisualIndicatorMode, indicator?: VisualIndicatorSetting) => {
      setSaving(true);
      try {
        return await saveVisualIndicator(token!, indicator ? { mode, indicator } : { mode });
      } finally {
        setSaving(false);
      }
    },
    [token],
  );

  const estimate = useCallback(() => getVisualIndicatorEstimate(token!), [token]);
  const status = useCallback((requestId: string) => getVisualIndicatorStatus(token!, requestId), [token]);
  const stop = useCallback((requestId: string) => stopVisualIndicator(token!, requestId), [token]);

  return { save, estimate, status, stop, saving, ready: Boolean(token) };
};

export default useVisualIndicator;
